import React from 'react';
import { RouteComponentProps } from 'react-router';
import { MaybeUser } from '@soluto-home-web/smart-home-support/pages/auth/models';
import { Hero, ValuePropositions, FinePrint, ProtectIt } from './components';
import CalculatorSelectionPage from '../calculator/selection';
import CalculatorResultsPage from '../calculator/results';
import { CalculatorResultsPageProps } from '../calculator/models';
import ErrorBoundary from '../../components/ErrorBoundary';
import TestimonialSection from '../../components/TestimonialSection';
import defaultCompetitors from '../../resources/calculator/competitors.json';
import defaultDevices from '../../resources/calculator/devices.json';
import { PartnerContent } from 'packages/smart-home-support/partner';

const HomePage: React.FunctionComponent<RouteComponentProps & CalculatorResultsPageProps> = (props) => {
  let { competitors, devices } = props;

  if (!competitors || typeof competitors !== 'object') {
    competitors = defaultCompetitors;
  }

  if (!devices || typeof devices !== 'object') {
    devices = defaultDevices;
  }

  return (
    <>
      <ErrorBoundary>
        <Hero />
      </ErrorBoundary>

      <ErrorBoundary>
        <CalculatorSelectionPage {...props} />
      </ErrorBoundary>

      <ErrorBoundary>
        <ProtectIt {...props} competitors={competitors} devices={devices} />
      </ErrorBoundary>

      <ErrorBoundary>
        <ValuePropositions />
      </ErrorBoundary>

      <PartnerContent TechCoachHome={<div style={{ height: '30px' }} />}>
        <ErrorBoundary>
          <CalculatorResultsPage {...props} competitors={competitors} devices={devices} />
        </ErrorBoundary>

        <ErrorBoundary>
          <FinePrint />
        </ErrorBoundary>

        <ErrorBoundary>
          <TestimonialSection />
        </ErrorBoundary>
      </PartnerContent>
    </>
  );
};

export default HomePage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/index.tsx